import { loadRuntimeConfigScript } from '@wky/common';

async function bootstrap() {
  await loadRuntimeConfigScript('/runtime-config.js');
  await import('./main');
}

void bootstrap();
